<div class="flex flex-col h-full">
  <p-toolbar>
    <ng-template pTemplate="start">
      <p-button
        routerLink="/konvertering"
        icon="pi pi-arrow-left"
        label="Tilbage til listen"
        class="mr-2"
        text
        severity="secondary"
        outlined />
    </ng-template>
  </p-toolbar>
  @if (data.isLoading()) {
    <div class="text-center mt-8">
      <app-let-loading-indicator />
    </div>
  } @else {
    <div class="flex-1 flex flex-wrap gap-4 mt-4 overflow-hidden">
      <p-panel class="!w-[400px] h-full" header="Konvertering">
        <table>
          <tr>
            <td class="font-semibold w-36">Navn:</td>
            <td>{{ konvertering().navn }}</td>
          </tr>
          <tr>
            <td class="font-semibold">Fra Hreg:</td>
            <td>{{ konvertering().fraHreg }}</td>
          </tr>
          <tr>
            <td class="font-semibold">Til Hreg:</td>
            <td>{{ konvertering().tilHreg }}</td>
          </tr>
          <tr>
            <td class="font-semibold">K-Dag:</td>
            <td>{{ konvertering().kDag | date: 'dd-MM-yyyy' }}</td>
          </tr>
        </table>
      </p-panel>
      <p-panel class="flex-1 h-full overflow-hidden" header="Udtræk">
        <div class="flex gap-8">
          @for (
            regnr of [konvertering().fraHreg, konvertering().tilHreg];
            track regnr
          ) {
            <div>
              <div class="font-bold">Hreg: {{ regnr }}</div>
              <div class="flex flex-col gap-2 mt-2 mb-4 w-80">
                @for (u of konvertering().udtraek; track u.id) {
                  @if (u.hreg == regnr) {
                    <a
                      pButton
                      [routerLink]="['konverteringdata', u.id]"
                      target="_blank"
                      style="text-decoration: none; font-weight: 600">
                      {{ u.type }}
                    </a>
                  }
                }
              </div>
            </div>
          }
        </div>
      </p-panel>
    </div>
  }
</div>
